import React, { Component } from 'react';
import { Icon } from 'antd';
import styled from 'styled-components';
const Root = styled.div `
   .card{
      height:100px;
      color: #FFFFFF;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      border-radius: 3px;
      padding:0 25px;
      .card-title{
        font-size: 16px;
        display: flex;
        align-items: center;
        .card-desc{
          display: flex;
          align-items: center;
          .icon{
            margin-left:5px;
            width:15px;
            height:15px;
            background: #FFFFFF;
            border-radius: 50%;
            color:#FBCC33;
            display: flex;
          }
          .desc{
            font-size: 14px;
            position: relative;
            top:20px;
            display: none;
            animation: fadeIn 0.5s;
          }
        }
        .card-desc:hover{
          .desc{
            display: block;
          }
        }
      }
      .card-content{
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        .card-num{
            font-size: 35px;
            line-height: 35px;
            margin-right: 10px;
        }
      }
   }


  @keyframes fadeIn {
    0% {
    opacity: 0;
    }
    100% {
    opacity: 1;
    }
  }

`;
class Card extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps && (nextProps.num === this.props.num)) {
            return false;
        }
        return true;
    }
    render() {
        const { themeColor, title, desc, num, unit, className, } = this.props;
        return (<Root className={className}>
        <div className="card" style={{ background: themeColor }}>
          <div className="card-title">
            <div>{title}</div>
            {desc && (<div className="card-desc">
                  <div className="icon">
                    <Icon type="question" style={{ fontSize: '14px', fontWeight: 'bold' }}/>
                  </div>
                  <div className="desc">{desc}</div>
                </div>)}
          </div>
          <div className="card-content">
            <div className="card-num">{num}</div>
            <span>{unit}</span>
          </div>
        </div>
      </Root>);
    }
}
Card.defaultProps = {
    themeColor: '#FFFFFF',
    title: '',
    desc: null,
    num: '',
    unit: '辆',
    className: '',
};
export default Card;
